export const SVG_FILL_MODE = {
  FILL: 'fill', // set color to fill prop
  STROKE: 'stroke' // set color to stroke prop
};
